import React from 'react';

const Home: React.FC = () => <section aria-label="home" />;

export default Home;
